module.exports = "/_next/static/images/58a06362fa6af26884cc1975a599530d-check-circle.svg.webp";